import React from "react";

import { ShiftCalendar } from "./ShiftCalendar";
import { ShiftListing } from "./ShiftListing";

/**
 * This function renders the DashboardShifts component, which contains a ShiftCalendar and ShiftListing.
 *
 * @return {JSX.Element} The DashboardShifts component
 */
export const DashboardShifts = () => {
  return (
    <div className="DashboardShifts_Wrapper flex gap-4 max-lg:flex-col">
      <ShiftCalendar />
      <ShiftListing />
    </div>
  );
};
